webpackJsonp([247980382478648],{

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavLink = __webpack_require__(12);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _NavLinkPlaceholder = __webpack_require__(13);
	
	var _NavLinkPlaceholder2 = _interopRequireDefault(_NavLinkPlaceholder);
	
	__webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var children = props.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'docs-header', id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Publishing'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Documentation for deploying your application'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'docs-content' },
	        _react2.default.createElement(
	          'ul',
	          { id: 'markdown-toc' },
	          _react2.default.createElement(_NavLink2.default, { title: 'Introduction', url: '/publishing/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'Deploy Hosts'
	          ),
	          _react2.default.createElement(_NavLink2.default, { title: 'Now', url: '/publishing/providers/now/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'Misc'
	          ),
	          _react2.default.createElement(_NavLink2.default, { title: 'Removing Now Support', url: '/publishing/misc/removing-now/' })
	        ),
	        children
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Publishing = __webpack_require__(82);
	
	var _Publishing2 = _interopRequireDefault(_Publishing);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _Video = __webpack_require__(15);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Publishing2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Introduction'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section documents how to deploy your application.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Choosing a Hosting Provider'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once you build your application, it\'s really just a collection of static files, which means there are ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'a lot'
	      ),
	      ' of choices for services that you can use to host it. Some of those services include ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://pages.github.com/' },
	        'GitHub Pages'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://surge.sh/' },
	        'Surge'
	      ),
	      ', and ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://aws.amazon.com/s3/' },
	        'Amazon S3'
	      ),
	      ', and there are even rumors of some really adventurous folks hosting static applications from ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.dropbox.com' },
	        'DropBox'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'But if you\'re looking for a hosting service, you might want to consider trying out ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://zeit.co/now' },
	        'Now'
	      ),
	      ', which is a hosting service provided by ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://zeit.co/now' },
	        'zeit.co'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This particular service provides several advantages for hosting static applications, including:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'An easy deploy process'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Free SSL certificates for custom domains'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Zero-downtime deploys'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Ability to roll-back to previous deploys'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Provides an informative web dashboard'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Free global CDN, with data centers in USA and Europe'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'New Lore projects include support for deploying to Now by default, and you can find a walkthrough of what that process looks like in the navigation on the right.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you\'d prefer to use a different service to host your application, you can easily remove all traces of Now from your project by ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/publishing/misc/removing-now/' },
	        'following these steps'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-publishing-index-js-f3e797818cb5d5cc183d.js